import { Pipe, PipeTransform } from '@angular/core';
import { smartTitle } from './smart-capitalize';

@Pipe({
  name: 'smartCapitalize',
})
export class SmartCapitalizePipe implements PipeTransform {
  transform(text: string): string {
    return smartTitle(text);
  }
}
